import { keys } from 'ramda';
import { SENIOR_MANAGER, MANAGER } from './roles';

export const COMPANY_SIZE = [
    '1-50',
    '51-100',
    '101-300',
    '301-1 000',
    '1 001-10 000',
    'Более 10 000'
].map(value => ({ id: value, value }));

export const COMPANY_INDUSTRY = [
    'Атомная промышленность',
    'Банки, финансовые, страховые компании',
    'Государственные учреждения',
    'Индустрия гостеприимства (HoReCa)',
    'Информационные технологии',
    'Легкая промышленность',
    'Логистика, транспорт',
    'Машиностроение',
    'Медицина',
    'Металлургия',
    'Некоммерческие организации',
    'Производство аудио, видео, бытовой техники',
    'Производство промышленных товаров и средств производства',
    'Производство товаров повседневного спроса (FMCG и пищевая промышленность)',
    'Реклама и медиа',
    'Строительная отрасль',
    'Телекоммуникации',
    'Торговля и розничные сети',
    'Угольная промышленность',
    'Фармацевтика',
    'Химическая и нефтехимическая промышленность',
    'Электроэнергетика',
    'Иное'
].map(value => ({ id: value, value }));

export const COMPANY_PAGE_COLORS = [
    { field: 'background', title: 'Фон страницы', default: '#FCFCFC' },
    { field: 'text', title: 'Текст', default: '#000000' },
    { field: 'header', title: 'Фон шапки', default: '#ffffff' },
    { field: 'headerText', title: 'Текст в шапке', default: '#000000' },
    { field: 'footer', title: 'Фон футера', default: '#ffffff' },
    { field: 'footerText', title: 'Текст в футере', default: '#000000' },
    { field: 'questionHeader', title: 'Фон шапки вопроса', default: '#f1f1f1' },
    { field: 'questionHeaderText', title: 'Текст в шапке вопроса', default: '#000' },
    { field: 'elementStatistic', title: 'Элементы статики', default: '#F3F3F3' },
    { field: 'textInput', title: 'Текст элементов управления', default: '#000000' },
    { field: 'input', title: 'Элементы управления', default: '#f54d2e' }
];

export const COMPANY_PAGE_FONTS = [
    { value: 'Arial, sans-serif', label: 'Arial' },
    { value: 'Arial Black, sans-serif', label: 'Arial Black' },
    { value: 'Comic Sans MS, cursive', label: 'Comic Sans MS' },
    { value: 'Courier New, monospace', label: 'Courier New' },
    { value: 'Georgia, serif', label: 'Georgia' },
    { value: 'Impact, sans-serif', label: 'Impact' },
    { value: 'Times New Roman, serif', label: 'Times New Roman' },
    { value: 'Trebuchet MS, sans-serif', label: 'Trebuchet MS' },
    { value: 'Verdana, sans-serif', label: 'Verdana' }
];

export const COMPANY_CLIENT_ROLES = [
    { id: SENIOR_MANAGER, value: 'Клиент-менеджер' },
    { id: MANAGER, value: 'Клиент-участник' }
];

export const COMPANY_TEMPLATE_VARIABLES = [
    { var: 'FirstName', title: 'Имя респондента' },
    { var: 'LastName', title: 'Фамилия респондента' },
    { var: 'MiddleName', title: 'Отчество' },
    { var: 'FullName', title: 'Полное имя респондента' },
    { var: 'Project', title: 'Название проекта' },
    { var: 'ManagerName', title: 'Мое имя' },
    { var: 'ManagerPhone', title: 'Мой телефон' },
    { var: 'ManagerEmail', title: 'Мой email' },
    { var: 'ManagerPosition', title: 'Моя должность' },
    { var: 'Company', title: 'Название компании' },
    { var: 'TestLink', title: 'Ссылка на прохождение теста' },
    { var: 'ReportLink', title: 'Ссылка на скачивание отчета' },
];

export const COMPANY_TEMPLATE_LETTER_VARIABLES = [
    { var: 'FirstName', title: 'Имя респондента' },
    { var: 'LastName', title: 'Фамилия респондента' },
    { var: 'MiddleName', title: 'Отчество' },
    { var: 'FullName', title: 'Полное имя респондента' },
    { var: 'Project', title: 'Название проекта' },
    { var: 'ManagerName', title: 'Мое имя' },
    { var: 'ManagerPhone', title: 'Мой телефон' },
    { var: 'ManagerEmail', title: 'Мой email' },
    { var: 'ManagerPosition', title: 'Моя должность' },
    { var: 'Company', title: 'Название компании' },
    { var: 'TestLink', title: 'Ссылка на прохождение теста' },
];

export const COMPANY_PARTICIPANT_REPORT_TEMPLATE_VARIABLES = [
    { var: 'FirstName', title: 'Имя респондента' },
    { var: 'LastName', title: 'Фамилия респондента' },
    { var: 'MiddleName', title: 'Отчество' },
    { var: 'FullName', title: 'Полное имя респондента' },
    { var: 'Project', title: 'Название проекта' },
    { var: 'ManagerName', title: 'Мое имя' },
    { var: 'ManagerPhone', title: 'Мой телефон' },
    { var: 'ManagerEmail', title: 'Мой email' },
    { var: 'ManagerPosition', title: 'Моя должность' },
    { var: 'Company', title: 'Название компании' },
    { var: 'ReportLink', title: 'Ссылка на скачивание отчета' },
];

export const AUDIT_TEMPLATE_VARIABLES = [
    { var: 'FirstName', title: 'Имя эксперта' },
    { var: 'LastName', title: 'Фамилия эксперта' },
    { var: 'TestLink', title: 'Ссылка на прохождение теста' },
    { var: 'Test', title: 'Название теста' },
];

export const TEMPLATE_VARIABLES = [
    ...COMPANY_TEMPLATE_VARIABLES,
    ...AUDIT_TEMPLATE_VARIABLES,
];

export const COMPANY_PROJECT_STATUSES = [
    { id: 'active', value: 'Активные', single: 'Активный' },
    { id: 'hidden', value: 'Скрытые', single: 'Скрытый' }
];

export const PROJECT_RESPONDENT_STATUSES = [
    { id: 'created', value: 'Не выслан', color: 'orange', pieColor: 'rgb(247, 70, 74)', ppxColor: 'F7464A', dateField: ['createdAt'] },
    { id: 'sent', value: 'Выслан', color: 'purple', pieColor: 'rgb(253, 180, 92)', ppxColor: 'FDB45C', dateField: ['createdAt'] },
    { id: 'started', value: 'В работе', color: 'blue', pieColor: '#36A2EB', ppxColor: '36A2EB', dateField: ['_embedded', 'solution', 'startedAt'] },
    { id: 'finished', value: 'Пройден', color: 'green', pieColor: 'rgb(70, 191, 189)', ppxColor: '46BFBD', dateField: ['_embedded', 'solution', 'finishedAt'] }
];

export const PROJECT_RESPONDENT_STATUS_NAMES = {
    'created': 'Не выслан',
    'sent': 'Выслан',
    'started': 'В работе',
    'finished': 'Пройден',
};

export const PROJECT_RESPONDENT_EMPLOYEE = [
    { id: false, value: 'Кандидат' },
    { id: true, value: 'Сотрудник' }
];

export const TIME_LIMITED_BY = [
    { id: 'test', value: 'всего теста' },
    { id: 'question', value: 'каждого вопроса' }
];

export const PROJECT_DEFAULT_DESIGN_DESCRIPTION = '<p><strong>Инструкция</strong></p>\n<p>Целью данной процедуры является определение уровня ваших профессиональных знаний. Данная процедура рассчитана на самостоятельное прохождение тестовых заданий - участником тестирования, получившим данную ссылку (без участия третьих лиц).&nbsp;</p>\n<p>На прохождение теста отведено определенное время. C момента нажатия кнопки &laquo;Начать тестирование&raquo; начнётся обратный отсчет.</p>\n<p>Для прохождения тестирования Вам нужно выбрать подходящий, на ваш взгляд, ответ и нажать на кнопку &laquo;Ответить&raquo;. Пожалуйста, НЕ используйте кнопку "назад" вашего браузера во время тестирования, поскольку Вы НЕ можете изменить ваши ответы после того, как Вы нажали на кнопку &laquo;Ответить&raquo;.</p>\n<p>Если страница с тестом случайно закрылась, то для возобновления участия в тестировании необходимо зайти еще раз по ссылке, указанной в письме.</p>\n<p>Если с момента нажатия кнопки &laquo;Начать тестирование&raquo; прошло больше отведенного на тест времени, то тест считается завершенным и пройти тест повторно уже невозможно.</p>\n<p>После ответа на последний вопрос и нажатия кнопки &laquo;Завершить тестирование&raquo; Ваши результаты сохраняются. Ссылка в Вашем письме становится недоступной для повторного использования.</p>';

export const INTEGRAL_RESULT = [
    { tooltip: 'Соответствует профилю с превосходством', from: .9, to: 1, color: '#549E38' },
    { tooltip: 'Соответствует профилю', from: .7, to: .89, color: '#93CD57' },
    { tooltip: 'Условно соответствует профилю', from: .5, to: .69, color: '#f9b57c' },
    { tooltip: 'Не соответствует профилю', from: 0, to: .49, color: '#f54d2e' }
];

export const PAYMENT_TYPES = [
    { id: 'pre', value: 'Предоплата' },
    { id: 'post', value: 'Постоплата' }
];

export const DISTRIBUTION = [
    { id: 'simple', value: 'Простое распределение' },
    { id: 'case', value: 'Распределение с кейсами' }
];

export const PAYMENTS_STATUSES = {
    'request': 'Формируется',
    'confirmedByEnsi': 'Сформирован',
    'paid': 'Оплачен',
    'credit': 'Оплачен в кредит',
    'paidPartial': 'Оплачен частично',
    'rejectedByEnsi': 'Отклонен'
};

export const PAYMENTS_STATUSES_FILTER = keys(PAYMENTS_STATUSES).map(id => ({ id, value: PAYMENTS_STATUSES[id] }));

export const PAYMENT_STATUSES_LINK = ['confirmedByEnsi', 'paid', 'paidPartial'];

export const MESSAGE_HISTORY_TYPE = [
    { id: 'consumer', value: 'Входящие' },
    { id: 'producer', value: 'Исходящие' },
    { id: '', value: 'Все' }
];

export const REPORT_TYPES_OPTIONS = [
    { id: 'default', value: 'Стандартный' },
    { id: 'integralResultScale', value: 'С выводом' },
    { id: 'competenceResult', value: 'Для теста на управление исполнением' },
    { id: 'evraz', value: 'Для компании Евраз' },
];

export const REPORT_TYPES = {
    'default': 'Стандартный',
    'integralResultScale': 'С выводом',
    'competenceResult': 'Для теста на управление исполнением',
    'evraz': 'Для компании Евраз',
};
